/* eslint-disable */
import React from 'react';

/**
 * @export
 * @type {React.Context<Entries>}
 */
const EntriesContext = React.createContext();

export default EntriesContext;
